/// <reference path="../../../../../typings/tsd.d.ts" /> 
//# sourceMappingURL=IWorkflowBlock.js.map